var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject, Prop, Vue, } from "vue-property-decorator";
let Gltf = class Gltf extends Vue {
    mounted() {
        if (this.networkBroker.configuration.loadGltf) {
            const gltf = this.$el.querySelector(".gltf-content");
            if (gltf !== undefined && gltf !== null) {
                this.renderer = new this.Renderer3d(gltf);
                this.renderer.display(this.content);
            }
        }
    }
};
__decorate([
    Prop({ required: true })
], Gltf.prototype, "content", void 0);
__decorate([
    Prop({ required: true })
], Gltf.prototype, "Renderer3d", void 0);
__decorate([
    Inject()
], Gltf.prototype, "networkBroker", void 0);
Gltf = __decorate([
    Component({
        components: {},
        name: "Gltf",
    })
], Gltf);
export default Gltf;
